Auth = require 'app/scripts/db/auth'
Label = require 'app/scripts/models/label'
Member = require 'app/scripts/models/member'
MemberAvatar = require 'app/scripts/views/member/member-avatar-react'
ModelCache = require 'app/scripts/db/model-cache'
ModelCacheListener = require 'app/scripts/views/internal/model-cache-listener'
React = require 'react'
{ Storage } = require '@trello/storage'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
localizeCount = require 'app/scripts/lib/localize-count'
t = require('app/scripts/views/internal/recup-with-helpers')('home_up_next')
{ trackUe } = require '@trello/analytics'
{ CanonicalCard } = require 'app/scripts/views/canonical-card/canonical-card-components'
{ CanonicalDetail } = require 'app/scripts/views/canonical-detail/canonical-detail-components'
{ BoardAndDetailContainer } = require('@atlassian/trello-canonical-components').CanonicalDetail
{ getOverflowItems, UP_NEXT_TYPE } = require 'app/scripts/views/home/overflow-menu'
{ getTrackingPrepObj, getTrackingIndObj } = require './presentational/util/up-next'
{ siteDomain } = require '@trello/config'

class UpNext extends React.Component
  displayName: 'UpNext'

  constructor: (props) ->
    super props

    { boardId, item, modelCache, cardId } = props

    @dueSoon = item.type == 'dueSoon'
    @action = item.type == 'action'
    @actionItem = modelCache.get('Action', item?.actionId)
    idMemberCreator = @actionItem?.get('idMemberCreator')
    @actionMemberCreator = if @actionItem && idMemberCreator then modelCache.get('Member', idMemberCreator, modelCache: modelCache)

    @isEdited = @actionItem && @actionItem.data?.dateLastEdited
    @isComment = @actionItem?.get('type') == 'commentCard'
    @isAddMemberToCard = @actionItem?.get('type') == 'addMemberToCard'

    board = @getModelFromModelCache('Board', boardId)
    @canReply = (@isComment || @isAddMemberToCard) && @actionMemberCreator && board?.canComment(Auth.me())

    @state = {
      isReplying: false
      isWaitingForNetworkResponse: false
      replyMessage: if @canReply && !Auth.isMe(@actionMemberCreator) then "@#{@actionMemberCreator?.get('username')} " else ''
      replyFailedStatusCode: null
    }

    @trackingPrepositionalObject = @getTrackingPrepositionalObject()
    @trackingIndirectObject = @getTrackingIndirectObject()

    @onReplyClick = @onReplyClick.bind(@, cardId, @actionItem?.id)
    @onSaveClick = @onSaveClick.bind(@, cardId, @actionItem?.id)
    @onCancelClick = @onCancelClick.bind(@, cardId, @actionItem?.id)
    @onChangeReplyMessage = @onChangeReplyMessage.bind(@)
    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@, cardId)
    @dismissCard = @dismissCard.bind(@)
    @onCompleteClick = @onCompleteClick.bind(@, cardId)
    @trackOverflowMenuOpens = @trackOverflowMenuOpens.bind(@)

  componentDidMount: ->
    @listenOnCardChange()

    commentDraftText = Storage.get @_commentDraftKey()
    if commentDraftText
      @setState replyMessage: commentDraftText

  componentDidUpdate: (prevProps) ->
    if prevProps.cardId != @props.cardId
      @props.clearModelListeners()
      @listenOnCardChange()

  getModelFromModelCache: (type, id) =>
    @props.modelCache.get(type, id)

  listenOnCardChange: =>
    card = @getModelFromModelCache('Card', @props.cardId)
    @props.modelListener card, 'change', =>
      if @props.item.type == 'dueSoon' && !card.getDueDate()
        @props.optimisticallyDismissCard(@props.upNextId, true, false)

      @forceUpdate()

  getUpNextTypeInfo: ->
    return {
      isComment: @isComment
      isDueSoon: @dueSoon
      isAddMemberToCard: @isAddMemberToCard
      isActionCreatorMe: @actionMemberCreator && Auth.isMe(@actionMemberCreator)
      hasMeAsMember: @getModelFromModelCache('Card', @props.cardId)?.hasMember(Auth.myId())
    }

  getTrackingPrepositionalObject: ->
    getTrackingPrepObj(@getUpNextTypeInfo())

  getTrackingIndirectObject: ->
    getTrackingIndObj(@getUpNextTypeInfo())

  trackOverflowMenuOpens: (cardId) ->
    trackUe('home', 'opens', 'overflow menu', '', @trackingIndirectObject, 'by clicking overflow menu icon on up next card', { cardId: cardId })

  onReplyClick: (cardId, actionId, event) ->
    actionVerb = if !@state.isReplying then 'opens' else 'dismisses'
    trackUe('home', actionVerb, 'comment field', '', @trackingIndirectObject, 'by clicking reply on up next card', { cardId: cardId, actionId: actionId })
    @setState (prevState) -> isReplying: !prevState.isReplying

  onCancelClick: (cardId, actionId, event) ->
    trackUe('home', 'dismisses', 'comment field', '', @trackingIndirectObject, 'by clicking cancel on up next card', { cardId: cardId, actionId: actionId })
    @setState isReplying: false

  _commentDraftKey: -> "draft_#{@props.upNextId}_comment"

  onChangeReplyMessage: (e) ->
    Util.preventDefault(e)
    commentText = e.target.value
    @setState replyMessage: commentText
    if commentText
      Storage.set @_commentDraftKey(), commentText
    else
      Storage.unset @_commentDraftKey()
    return

  onSaveClick: (cardId, actionId, event) ->
    if @canReply
      { optimisticallyDismissCard, upNextId } = @props
      trackUe('home', 'adds', 'comment', '', @trackingIndirectObject, 'by clicking save on up next card', { cardId: cardId, actionId: actionId })
      @setState isWaitingForNetworkResponse: true
      @getModelFromModelCache('Card', cardId)?.addComment(@state.replyMessage)
        .then =>
          @setState isWaitingForNetworkResponse: false
          optimisticallyDismissCard(upNextId)
        .catch (error) =>
          @setState {
            replyFailedStatusCode: error.status || true
            isWaitingForNetworkResponse: false
          }

  dismissCard: ->
    { card, dismissUpNextCard, upNextId } = @props

    dismissUpNextCard(card?.get('id'), upNextId, @trackingPrepositionalObject)

  onCompleteClick: (cardId, event) ->
    { cardId, optimisticallyDismissCard, upNextId } = @props

    trackUe('home', 'completes', 'card', @trackingPrepositionalObject, '', 'by clicking complete button in up next feed', { cardId: cardId })
    @getModelFromModelCache('Card', cardId).update({ dueComplete: true })
    optimisticallyDismissCard(upNextId)

  trackOnClickCanonicalCard: (cardId, event) ->
    trackUe('home', 'opens', 'card', @trackingPrepositionalObject, '', 'by clicking card in up next feed', { cardId: cardId })

  render: t.renderable ->
    { boardId, cardId, idAction, item, listId, modelCache, orgId, reactionList, setFocusedCard, upNextId } = @props
    { isReplying, isWaitingForNetworkResponse, replyMessage, replyFailedStatusCode } = @state

    board = @getModelFromModelCache('Board', boardId)
    card = @getModelFromModelCache('Card', cardId)
    org = @getModelFromModelCache('Organization', boardId)
    list = @getModelFromModelCache('List', listId)

    _tfmFormatOpts = {
      card
      board
      siteDomain
      textData: @actionItem?.data?.textData
    }

    t.tag BoardAndDetailContainer, { width: 420 }, =>
      t.div { onClick: @trackOnClickCanonicalCard }, =>
        t.tag CanonicalCard, {
          board
          boardClassName: 'canonical-stretch'
          canRemove: false
          card
          cardClassName: 'canonical-stretch'
          labels: card.getLabels()?.sort(Label.compare)
          list
          lightBackground: true
          members: card.memberList?.models
          numNotifications: 0
          organization: org
        }

      t.div =>
        t.tag CanonicalDetail, {
          @dueSoon
          @trackOverflowMenuOpens
          actionMemberCreator: @actionMemberCreator
          board
          canDismiss: true
          canReply: @canReply
          cardId
          collapseComment: @isComment
          commentText: if @isComment then TFM.comments.format(@actionItem?.get('display')?.entities?.comment?.text, _tfmFormatOpts).output
          date: @actionItem?.get('date')
          dueDate: card.get('badges')?.due
          idAction
          isActionMemberCreatorDeleted: @actionItem?.get('display')?.entities?.memberCreator?.translationKey == 'action_deleted_account'
          isAddMemberToCard: @isAddMemberToCard
          isEdited: @isEdited
          isReplying
          isWaitingForNetworkResponse
          memberCreator: Auth.me()
          onCancelClick: @onCancelClick
          onChangeReplyMessage: @onChangeReplyMessage
          onCompleteClick: @onCompleteClick
          onDismissClick: @dismissCard
          onReplyClick: @onReplyClick
          onSaveClick: @onSaveClick
          overflowMenuItems: getOverflowItems(card, UP_NEXT_TYPE, modelCache, @getUpNextTypeInfo())
          reactionList
          replyFailedStatusCode
          replyMessage
          setFocusedCard: => setFocusedCard(card)
        }

module.exports = ModelCacheListener(UpNext)
